<template>
  <div>
    <v-list>
      <template v-for="level1Menu in filteredLinks">
        <v-list-item
          v-if="
            level1Menu.menuLevel === 1 && level1Menu.menuAction !== 'dropdown'
          "
          :key="level1Menu.alias"
          v-on:click="goToLink(level1Menu.to)"
        >
          <v-list-item-action>
            <v-icon>{{ level1Menu.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title
              style="text-align: left"
              v-text="level1Menu.alias"
            ></v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group
          v-if="level1Menu.menuAction === 'dropdown'"
          :key="level1Menu.alias"
          :prepend-icon="level1Menu.icon"
          v-on:click="goToLink(level1Menu.to)"
        >
          <template v-slot:activator>
            <v-list-item style="padding: 0 !important; text-align:left">
              <v-list-item-title class="menuIE">{{
                level1Menu.alias
              }}</v-list-item-title>
            </v-list-item>
          </template>

          <template v-for="level2Menu in filteredLinks">
            <v-list-item
              v-if="level2Menu.menuLevel === 2"
              :key="level2Menu.alias"
              sub-group
              class="pointer"
              :to="level2Menu.to"
            >
              <v-list-item-action />
              <v-list-item-action>
                <v-icon class="level2MenuIcon grey--text text--lighten-1">{{
                  level2Menu.icon
                }}</v-icon>
              </v-list-item-action>
              <v-list-item-title
                style="text-align: left; padding-left: 10%"
                class="font-weight-normal"
                v-text="level2Menu.alias"
              ></v-list-item-title>
            </v-list-item>
          </template>
        </v-list-group>
      </template>
    </v-list>
  </div>
</template>

<script>
import { Snotify, SnotifyPosition, SnotifyToast } from "vue-snotify";

export default {
  name: "NavigationDrawer",
  data: () => ({
    links: [
      {
        menuAction: "link",
        to: "/",
        icon: "icons8-home",
        alias: "Home",
        menuLevel: 1,
        userLevel: 10,
      },
      {
        menuAction: "link",
        to: "/user-account",
        icon: "icons8-male-user-2",
        alias: "Account",
        menuLevel: 1,
        userLevel: 10,
      },
      {
        menuAction: "link",
        to: "/admin/users",
        icon: "icons8-user-group",
        alias: "Users",
        menuLevel: 1,
        userLevel: 100,
      },
      {
        menuAction: "link",
        to: "/admin/codes",
        icon: "icons8-access-3",
        alias: "Codes",
        menuLevel: 1,
        userLevel: 100,
      },
      {
        menuAction: "link",
        to: "/admin/courses",
        icon: "icons8-flipboard-2",
        alias: "Courses",
        menuLevel: 1,
        userLevel: 100,
      },
      {
        menuAction: "link",
        to: "/admin/topics",
        icon: "icons8-school-2",
        alias: "Topics Admin",
        menuLevel: 1,
        userLevel: 100,
      },
      {
        menuAction: "link",
        icon: "icons8-exit-2",
        alias: "Logout",
        menuLevel: 1,
        userLevel: 100,
      },

      // <v-icon
      //   v-if="$store.getters.currUser != null"
      //   class="white--text"
      //   @click="logout()"
      //   >icons8-exit-2</v-icon
      // >
      // // {
      //   menuAction: "link",
      //   to: "/contactform",
      //   icon: "icons8-google-forms-2",
      //   alias: "Contact Us",
      //   menuLevel: 1,
      //   userLevel: 10,
      // },
    ],
  }),
  computed: {
    filteredLinks() {
      // this.links.$filter((item) => {});
      var links = [];
      if (this.$store.getters.currUser != null) {
        for (var i = 0; i < this.links.length; i++) {
          if (
            this.links[i].userLevel <=
            parseInt(this.$store.getters.currUser.userTypeId)
          ) {
            links.push(this.links[i]);
          }
        }
      }

      return links;
    },
  },
  watch: {
    links() {
      this.filteredLinks();
    },
  },
  methods: {
   logout() {
      this.$snotify.confirm("Are you sure you want to log out?", "Log out", {
        titleMaxLength: 300,
        maxOnScreen: 1,
        closeOnClick: false,
        pauseOnHover: true,
        position: SnotifyPosition.centerCenter,
        buttons: [
          //Yes
          {
            text: "Yes",
            action: (toast) => this.yesAction(toast),
            bold: false,
          },
          //No
          { text: "No", action: (toast) => this.$snotify.remove(toast.id) },
        ],
      });
    },
    yesAction(toast) {
      this.$firebase.auth.signOut().then(() => {
        this.$router.push("/login").catch((err) => {});
        this.$store.commit("setUser", null);
      });
      this.$snotify.remove(toast.id);
    },
    goToLink(link) {
      if(link === undefined || link ===null){
        this.logout();
      }else{
        this.$router.push(link).catch((err) => {});
      }
      
    },
  },
};
</script>

<style>
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .menuIE {
    margin-top: 12%;
  }
}
</style>
